/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Body_upload_image_media_image_post = {
    properties: {
        file: {
            type: 'binary',
            isRequired: true,
            format: 'binary',
        },
    },
} as const;
